export default __webpack_public_path__ + "static/media/Kor-dark-logo.d5950d92.svg";